export default __webpack_public_path__ + "static/media/formulario_leches_medicamentosas-nuevo.9a0aeb1a.pdf";